export function getAppFileName(brand: string, platform: string): string {
  return `app-${brand}.${platform === 'ios' ? 'ipa' : 'apk'}`;
}
